import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';

import { RefreshToken } from '@/shared/modules/auth/components/RefreshToken/RefreshToken';
import { Toasts } from '@/shared/components/Toasts/Toasts';
import { ConfigProvider } from '@/shared/contexts/config';
import { I18nProvider } from '@/shared/contexts/i18n';
import { ThemeProvider } from '@/shared/contexts/theme';
import { TopMenuProvider } from '@/shared/contexts/top-menu';
import { ErrorBoundary } from '@/shared/errors/ErrorBoundary';
import { RumInitializer } from '@/shared/rum/RumInitializer';
import { queryClient } from '@/shared/api/queryClient';

import './publicPath';
import AppRouter from './routes';

import './style.css';

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <ConfigProvider>
      <RumInitializer />
      <RefreshToken />
      <I18nProvider>
        <ThemeProvider>
          <ErrorBoundary>
            <TopMenuProvider>
              <Toasts />
              <AppRouter />
            </TopMenuProvider>
          </ErrorBoundary>
        </ThemeProvider>
      </I18nProvider>
    </ConfigProvider>
  </QueryClientProvider>
);
